export const commonQuery = {
    'cityDictVal': {
        required: true,
        description: '请选择城市'          
    },
    // 'typeMeetVal': {
    //     required: true,
    //     description: '请选择会议类型'          
    // },    
}


// WEBPACK FOOTER //
// ./src/validatorConfig/commonQuery.js